import React from 'react';
import { Container, makeStyles } from '@material-ui/core';
import YearlyReportsTable from './yearly_reports_table';

const useStyles = makeStyles((theme) => ({
	container: {
		padding: theme.spacing(3, 2),
        maxWidth: 'none'
	},
    alignCenter: {
        textAlign: 'center'
    }
}));

const YearlyReportsList = () => {
    const { container } = useStyles();

    return (
        <Container className={container}>
            <YearlyReportsTable />
        </Container>
    )
}

export default YearlyReportsList;
